import { render, staticRenderFns } from "./HolidaysPayments.vue?vue&type=template&id=42747005&scoped=true&"
import script from "./HolidaysPayments.vue?vue&type=script&lang=ts&"
export * from "./HolidaysPayments.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42747005",
  null
  
)

export default component.exports